export default function isLiveEnvironment(): boolean {
  return window.location.hostname === "app.gyreteams.com";
}
